import { getSplitPaymentsAmountAlreadyAdded } from '../../helpers/payments';
import { getSplitPaymentSchema } from '../../types/payments';
import useSplitPayments from './useSplitPayments';

/**
 *
 * Derived state from the split payments group
 *
 */
function useSplitPaymentsState() {
  const {
    splitPaymentsGroup,
    paymentMethods,
    currentIndex,
    pendingTerminalPayment,
    form,
  } = useSplitPayments();

  const amountAlreadyAdded = getSplitPaymentsAmountAlreadyAdded(
    paymentMethods,
    currentIndex,
  );

  const currentPayment = paymentMethods[currentIndex];
  const isCurrentPaymentCreated = !!currentPayment?.paymentId;
  const isCurrentPaymentComplete =
    !!currentPayment && currentPayment?.isPaymentCollected;

  const isTerminalPending = !!pendingTerminalPayment;
  const paymentNumber = currentIndex + 1;

  const totalPriceCents = splitPaymentsGroup?.totalAmountCents || 0;
  const remainingAmount =
    Math.round(totalPriceCents - amountAlreadyAdded * 100) / 100;

  const amountNumber = form.amount ? Number(form.amount) : 0;
  const formToValidate = {
    ...form,
    amount: amountNumber,
  };

  const validationSchema = getSplitPaymentSchema(
    totalPriceCents,
    paymentMethods,
    currentIndex,
  );
  const isValid = validationSchema.isValidSync(formToValidate);

  const isComplete =
    totalPriceCents === (amountAlreadyAdded + amountNumber) * 100;

  return {
    amountAlreadyAdded,
    isCurrentPaymentCreated,
    isCurrentPaymentComplete,
    isTerminalPending,
    paymentNumber,
    remainingAmount,
    isValid,
    isComplete,
    totalPriceCents,
    validationSchema,
    parsedForm: formToValidate,
  };
}

export default useSplitPaymentsState;
